import TCarousel from './carousel.vue'
import TCarouselItem from './carousel-item.vue'

TCarousel.install = Vue => {
  Vue.component(TCarousel.name, TCarousel)
}

TCarouselItem.install = Vue => {
  Vue.component(TCarouselItem.name, TCarouselItem)
}

export {
  TCarousel,
  TCarouselItem
}



// WEBPACK FOOTER //
// ./src/module/carousel/index.js